<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/scriba'}">Dashboard</router-link>
          </li>
          <li>
            <router-link :to="{path:'/scriba/receipts'}">Receipts</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">&copy; CytoReason 2021</span>
          </template>
          <div>Made with ❤️ by Yoav Aharoni</div>
        </v-tooltip>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};

</script>
<style>

</style>
